Object.size = function (obj) {
  var size = 0,
    key
  for (key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) size++
  }
  return size
}

export const sleep = time => {
  return new Promise(resolve => setTimeout(resolve, time))
}

export const exists = order => {
  return order || order === 0 ? true : false
}

export const iOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

export const canVibrate = () => {
  return 'vibrate' in navigator && !iOS()
}

export const customVibrate = duration => {
  try {
    if (canVibrate()) {
      navigator.vibrate(duration)
    }
  } catch (e) {
    console.log(e)
  }
}

/* -------------------------------------------------------------------------- */
/*                                    Color                                   */
/* -------------------------------------------------------------------------- */

export const randomBetween = (a, b) =>
  Math.floor(Math.random() * (b - a + 1) + a)

const colorNoise = () => randomBetween(-10, 10)

// RGB to HEX
const _h = a => {
  let h = a.toString(16)
  return h.length === 1 ? '0' + h : h
}

export const toHex = (r, g, b) => _h(r) + _h(g) + _h(b)
export const toHexRgba = (r, g, b, a) => `${toHex(r, g, b)}${_h(a)}`

// https://stackoverflow.com/a/5624139/11069914
export const toRGB = hex => {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
    : null
}

export const getColor = colorTemplate => {
  return toRGB(colorTemplate.start).map(c =>
    // parseInt(constrain(c + colorNoise(), 0, 255))
    parseInt(constrain(c, 0, 255))
  )
}

// Interactions

export const onTextBlock = (e, parentText) => {
  return (
    (e.target.classList.contains('has-text-block') &&
      e.target.parentNode === parentText) ||
    (e.target.parentNode.classList.contains('has-text-block') &&
      e.target.parentNode.parentNode === parentText)
  )
}

export const onTextNode = (e, parentText) => {
  return (
    e.target.classList.contains('text-node') &&
    e.target.parentNode.parentNode === parentText
  )
}

export const onBlockButNotTextNode = (e, parentText) => {
  return (
    e.target.classList.contains('has-text-block') &&
    e.target.parentNode === parentText
  )
}

export const onControlsButton = e => {
  return e.target.type === 'button'
}

export const findNearbyTextNode = (e, target) => {
  const { touches } = e
  const touch = touches ? touches[0] : null
  if (!touch) return null

  let nearest = 9999 * 9999
  let nearestNode = null

  for (const node of target.children) {
    if (node.classList.contains('text-node')) {
      const thisRect = node.getBoundingClientRect()
      const dist = getRelativeDist(
        touch.clientX,
        touch.clientY,
        thisRect.left,
        thisRect.left + thisRect.width,
        thisRect.top,
        thisRect.top + thisRect.height
      )
      if (dist < nearest) {
        nearest = dist
        nearestNode = node
      }
    } else {
      continue
    }
  }

  return nearestNode
}

const getRelativeDist = (x, y, x1, x2, y1, y2) => {
  const distances = []
  for (let i of [x - x1, x - x2, y - y1, y - y2]) distances.push(Math.abs(i))
  return distances.reduce((a, b) => a + b, 0)
}

export const getTextBlock = e => {
  if (!e.target.parentNode) return null
  return e.target.classList.contains('has-text-block')
    ? e.target
    : e.target.parentNode.classList.contains('has-text-block')
    ? e.target.parentNode
    : null
}

export const getTextBlockFromTarget = target => {
  if (!target.parentNode) return null
  return target.classList.contains('has-text-block')
    ? target
    : target.parentNode.classList.contains('has-text-block')
    ? target.parentNode
    : null
}

export const setElementXY = (ele, x, y) => {
  ele.style.top = y + 'px'
  ele.style.left = x + 'px'
}

export const includeSelected = (start, l, target) => {
  if (target === null) return false
  return target >= start && target < start + l
}

export const includedByPseudo = (pseudoStart, pseudoEnd, targetStart) => {
  return targetStart >= pseudoStart && targetStart <= pseudoEnd
}

export const blockContainingNode = (seg, count) => {
  for (let s in seg) {
    if (includeSelected(seg[s].startCount, seg[s].length, count)) return seg[s]
  }
  return null
}

/* -------------------------------- PURE MATH ------------------------------- */

export const boundingRectCenter = rect => {
  return [rect.left + rect.width / 2, rect.top + rect.height / 2]
}

export const getTouchPosition = (e, ind = 0) => {
  if (e.clientX) return [e.clientX, e.clientY]
  if (e.touches && e.touches[ind])
    return [e.touches[ind].clientX, e.touches[ind].clientY]
  else return [0, 0]
}

export const touchBoundedBySelected = (e, selection) => {
  if (!selection) return false
  const [x, y] = getTouchPosition(e)
  const b = selection.getBoundingClientRect()

  return y < b.bottom && y > b.top && x < b.right && x > b.left
}

export const constrain = (a, min, max) => {
  return Math.max(Math.min(a, max), min)
}

export const map = (value, start1, stop1, start2, stop2, cap = false) => {
  let v =
    start2 + (stop2 - start2) * (((value - start1) * 1.0) / (stop1 - start1))
  let smaller2 = Math.min(start2, stop2)
  let bigger2 = Math.max(start2, stop2)
  return cap ? Math.min(Math.max(v, smaller2), bigger2) : v
}

export const dist = (aX, aY, bX, bY) => {
  return Math.hypot(aX - bX, aY - bY)
}

// Get unique items of an array
export const unique = arr => {
  return arr.filter((item, index) => arr.indexOf(item) === index)
}

export const uniqueByObjItem = (arr, item) => {
  return arr.filter(
    (i, index) => arr.findIndex(j => j[item] === i[item]) === index
  )
}

export const sumByItem = (array, item) => {
  return array.reduce((a, b) => a + b[item], 0)
}

// Find the number that is the most away from the start and the end numbers of the array
export const mostMiddleNumber = arr => {
  let maxDist = 0
  let midNum = null
  for (let i = 1; i < arr.length - 1; i++) {
    let dist =
      Math.abs(arr[i] - arr[0]) * Math.abs(arr[i] - arr[arr.length - 1])
    if (dist > maxDist) {
      maxDist = dist
      midNum = arr[i]
    }
  }
  return midNum
}

export const mostMiddleNumberByObjItem = (arr, item) => {
  let maxDist = 0
  let midNum = null
  for (let i = 1; i < arr.length - 1; i++) {
    let dist =
      Math.abs(arr[i][item] - arr[0][item]) *
      Math.abs(arr[i][item] - arr[arr.length - 1][item])
    if (dist > maxDist) {
      maxDist = dist
      midNum = arr[i]
    }
  }
  return midNum
}

export const arrLastN = (arr, n) => {
  if (arr.length <= n) return arr
  return arr.slice(arr.length - n)
}

export const blocksNotOverlapping = (a, b) => {
  return a.endCount < b.startCount || a.startCount > b.endCount
}

/* ---------------------------------- Chore --------------------------------- */

export const upperFirstLetter = s => {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const isEditTask = id => {
  if (!id) return false
  return id.includes('edit')
}
